module.exports = __webpack_public_path__ + "public/images/generated-counting-numbers.c2b9bf28ec42935f5697d2c8161e1619.jpg";